import flat from './flat'
import { SHOP_ID } from '@/utils/const'
import { confirmUrl } from './const'

/**
 * 我的页面数据
 */
export const getMineData = () => {
  ///api/mall/proxy/order/mine
  return flat(`${confirmUrl}/mine`)

  // return new Promise(resolve => {
  //   setTimeout(() => {
  //     resolve({
  //       data: {
  //         name: 'liyang',
  //         avatar: 'https://7n.bczcdn.com/r/ypnzxbx9a9wwz62cdu25hyuhkxyakjlb.png',
  //         collectCount: 10,
  //         couponCount: 12,
  //         cartGoodsCount: 14,
  //         orderCount: {
  //           waitingPayOrderCount: 1,
  //           waitingSendOrderCount: 2,
  //           waitingReceiveOrderCount: 4,
  //           waitingCommentOrderCount: 5,
  //         },
  //       },
  //     })
  //   }, 1000)
  // })
}

/**
 *
 * @param {number} orderId
 * @returns
 */
export const getExpressInfo = orderId => {
  return flat(`${confirmUrl}/order_logistics?orderId=${orderId}`)
}

/**
 * 获取订单列表
 * @param {object} opt
 * @param {number} [opt.status]
 * @param {boolean} [opt.canComment]
 * @param {number} opt.lastOrderId
 * @param {number} opt.pageSize
 */
export const getOrderList = opt => {
  ///order/list
  // const { status, canComment, pageIndex, pageSize } = opt
  return flat(`${confirmUrl}/order_list`, {
    method: 'POST',
    body: {
      ...opt,
    },
  })
}

/**
 * 删除订单
 * @param {number} orderId
 */
export const delOrder = orderId => {
  return flat(`${confirmUrl}/order_delete?orderId=${orderId}&shopId=${SHOP_ID}`)
}

/**
 * 申请退款
 * @param {number} orderId
 */
export const refoundOrder = orderId => {
  return flat(`${confirmUrl}/order_refund?orderId=${orderId}&shopId=${SHOP_ID}`)
}

/**
 * 根据id获取订单详情
 * @param {number} orderId
 * @returns
 */
export const getOrderDetailById = orderId => {
  return flat(`${confirmUrl}/order_info?orderId=${orderId}&shopId=${SHOP_ID}`)
}

/**
 * 订单取消
 * @param {number} orderId
 *
 */
export const cancelOrder = orderId => {
  return flat(`${confirmUrl}/order_cancel?orderId=${orderId}&shopId=${SHOP_ID}`)
}

/**
 * 签收订单
 * @param {number} orderId
 *
 */
export const receiveOrder = orderId => {
  return flat(`${confirmUrl}/order_receive?orderId=${orderId}&shopId=${SHOP_ID}`)
}

/**
 *
 * @param {{shopId: number,orderId:number,payType: number,productId: number,wxOpenId?: string}} opt
 * @returns
 */
export const payOrder = opt => {
  return flat(`${confirmUrl}/order_pay`, {
    method: 'POST',
    body: {
      ...opt,
    },
  })
}

/**
 * 添加评论
 * @param {number} orderId
 * @param {object} itemComments
 */
export const addComment = (orderId, itemComments) => {
  // console.log('orderId -----------', orderId, itemComments)
  // return new Promise(resolve => {
  //   setTimeout(() => {
  //     resolve({})
  //   }, 1000)
  // })
  ///api/mall/proxy/order/add_comment
  return flat(`${confirmUrl}/add_comment`, {
    method: 'POST',
    body: {
      orderId: orderId,
      itemComments: itemComments,
    },
  })
}
